<mat-list-item class="loading-item" *ngIf="isLoading" role="status">
  <span class="sr-only">Loading</span>
  <div class="lds-ellipsis" aria-hidden="true">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</mat-list-item>
